// extracted by mini-css-extract-plugin
export default {"root":"_1nXxN","icon":"_3fqQQ","title":"_1wbRt","subtitle":"HSSXT"};